import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates rails route to
 * /groups/*group_id/-/settings/reporting(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsReportingPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsReportingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsReportingPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsReportingPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsReportingPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification/:id/verify(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _verifyOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _verifyGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _verifyOrganizationGroupSettingsDomainVerificationPath(gon.current_organization.path, ...args);
  }

  return _verifyGroupSettingsDomainVerificationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification/:id/retry_auto_ssl(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryAutoSslGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _retryAutoSslOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _retryAutoSslGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _retryAutoSslOrganizationGroupSettingsDomainVerificationPath(gon.current_organization.path, ...args);
  }

  return _retryAutoSslGroupSettingsDomainVerificationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification/:id/clean_certificate(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanCertificateGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _cleanCertificateOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _cleanCertificateGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _cleanCertificateOrganizationGroupSettingsDomainVerificationPath(gon.current_organization.path, ...args);
  }

  return _cleanCertificateGroupSettingsDomainVerificationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsDomainVerificationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsDomainVerificationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsDomainVerificationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsDomainVerificationIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsDomainVerificationIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSettingsDomainVerificationPath(gon.current_organization.path, ...args);
  }

  return _newGroupSettingsDomainVerificationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/domain_verification/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsDomainVerificationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsDomainVerificationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_verification"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsDomainVerificationPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsDomainVerificationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/merge_requests(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsMergeRequestsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsMergeRequestsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsMergeRequestsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/roles_and_permissions(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsRolesAndPermissionsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsRolesAndPermissionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsRolesAndPermissionsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsRolesAndPermissionsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsRolesAndPermissionsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/roles_and_permissions/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSettingsRolesAndPermissionPath(gon.current_organization.path, ...args);
  }

  return _newGroupSettingsRolesAndPermissionPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/roles_and_permissions/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSettingsRolesAndPermissionPath(gon.current_organization.path, ...args);
  }

  return _editGroupSettingsRolesAndPermissionPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/roles_and_permissions/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsRolesAndPermissionPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsRolesAndPermissionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"roles_and_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsRolesAndPermissionPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsRolesAndPermissionPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/orbit(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsOrbitPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsOrbitPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"orbit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsOrbitPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"orbit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsOrbitPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsOrbitPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo/seat_utilization(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"seat_utilization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoSeatUtilizationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"seat_utilization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoSeatUtilizationIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoSeatUtilizationIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo/configuration(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoConfigurationIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoConfigurationIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoConfigurationIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo/model_selection(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"model_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoModelSelectionIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"model_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoModelSelectionIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoModelSelectionIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo/governance(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"governance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"governance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoGovernanceIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoGovernanceIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_credits_dashboard(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabCreditsDashboardIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabCreditsDashboardIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabCreditsDashboardIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_credits_dashboard/users/:username
 * @param {any} groupId
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"username":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[3,"username"]]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabCreditsDashboardUserPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"username":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_credits_dashboard"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[3,"username"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabCreditsDashboardUserPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabCreditsDashboardUserPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/gitlab_duo_usage(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsGitlabDuoUsagePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsGitlabDuoUsagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsGitlabDuoUsagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsGitlabDuoUsagePath(gon.current_organization.path, ...args);
  }

  return _groupSettingsGitlabDuoUsagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/workspaces(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsWorkspacesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsWorkspacesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsWorkspacesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsWorkspacesPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsWorkspacesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/work_items(/*vueroute)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workItemsGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _workItemsOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _workItemsGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _workItemsOrganizationGroupSettingsWorkItemsPath(gon.current_organization.path, ...args);
  }

  return _workItemsGroupSettingsWorkItemsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/work_items/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSettingsWorkItemsPath(gon.current_organization.path, ...args);
  }

  return _newGroupSettingsWorkItemsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/work_items/edit(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSettingsWorkItemsPath(gon.current_organization.path, ...args);
  }

  return _editGroupSettingsWorkItemsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/work_items(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsWorkItemsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsWorkItemsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/issues(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsIssuesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsIssuesPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsIssuesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/settings/packages_and_registries/virtual_registry_cleanup_policy(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"virtual_registry_cleanup_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"virtual_registry_cleanup_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsPackagesAndRegistriesVirtualRegistryCleanupPolicyIndexPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/group_members/:id/override(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overrideGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _overrideOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _overrideGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"override"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _overrideOrganizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _overrideGroupGroupMemberPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/group_members/:id/unban(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbanGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _unbanOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _unbanGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unbanOrganizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _unbanGroupGroupMemberPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/group_members/:id/ban(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _banOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _banGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _banOrganizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _banGroupGroupMemberPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/group_members/export_csv(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvGroupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _exportCsvOrganizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _exportCsvGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _exportCsvOrganizationGroupGroupMembersPath(gon.current_organization.path, ...args);
  }

  return _exportCsvGroupGroupMembersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/two_factor_auth(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _groupTwoFactorAuthPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/contribution_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupContributionAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupContributionAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"contribution_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupContributionAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"contribution_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupContributionAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupContributionAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/ci_cd(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCiCdAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCiCdAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCiCdAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/dashboards(/*vueroute)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsDashboardsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsDashboardsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsDashboardsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/devops_adoption(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"devops_adoption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsDevopsAdoptionPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"devops_adoption"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsDevopsAdoptionPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsDevopsAdoptionPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/productivity_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"productivity_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsProductivityAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"productivity_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsProductivityAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsProductivityAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/coverage_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCoverageReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCoverageReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCoverageReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCoverageReportsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCoverageReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/merge_request_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsMergeRequestAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsMergeRequestAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/repository_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"repository_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsRepositoryAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"repository_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsRepositoryAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsRepositoryAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average_duration_chart(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _averageDurationChartOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _averageDurationChartOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, ...args);
  }

  return _averageDurationChartGroupAnalyticsCycleAnalyticsValueStreamStagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/median(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medianGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _medianOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _medianGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _medianOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, ...args);
  }

  return _medianGroupAnalyticsCycleAnalyticsValueStreamStagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const averageGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _averageOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _averageGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _averageOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, ...args);
  }

  return _averageGroupAnalyticsCycleAnalyticsValueStreamStagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/records(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _recordsOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _recordsOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, ...args);
  }

  return _recordsGroupAnalyticsCycleAnalyticsValueStreamStagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/count(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (...args) => {
  const _countOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _countGroupAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _countOrganizationGroupAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, ...args);
  }

  return _countGroupAnalyticsCycleAnalyticsValueStreamStagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages(.:format)
 * @param {any} groupId
 * @param {any} valueStreamId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamStagesPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamStagesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamsPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _newGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, ...args);
  }

  return _newGroupAnalyticsCycleAnalyticsValueStreamPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, ...args);
  }

  return _editGroupAnalyticsCycleAnalyticsValueStreamPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/value_streams/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsValueStreamPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/summary(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsSummaryPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsSummaryPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/time_summary(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsTimeSummaryPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsTimeSummaryPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/lead_times(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"lead_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsLeadTimesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"lead_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsLeadTimesPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsLeadTimesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/value_stream_analytics/cycle_times(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"cycle_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsCycleAnalyticsCycleTimesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"cycle_times"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsCycleAnalyticsCycleTimesPath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsCycleAnalyticsCycleTimesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/type_of_work/tasks_by_type/top_labels(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topLabelsGroupAnalyticsTasksByTypePath = /*#__PURE__*/ (...args) => {
  const _topLabelsOrganizationGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[2,[7,"/"],[2,[6,"top_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _topLabelsGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[2,[7,"/"],[2,[6,"top_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _topLabelsOrganizationGroupAnalyticsTasksByTypePath(gon.current_organization.path, ...args);
  }

  return _topLabelsGroupAnalyticsTasksByTypePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/analytics/type_of_work/tasks_by_type(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAnalyticsTasksByTypePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupAnalyticsTasksByTypePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"type_of_work"],[2,[7,"/"],[2,[6,"tasks_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAnalyticsTasksByTypePath(gon.current_organization.path, ...args);
  }

  return _groupAnalyticsTasksByTypePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/ldap/sync(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncGroupLdapPath = /*#__PURE__*/ (...args) => {
  const _syncOrganizationGroupLdapPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _syncGroupLdapPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _syncOrganizationGroupLdapPath(gon.current_organization.path, ...args);
  }

  return _syncGroupLdapPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/issues_analytics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIssuesAnalyticsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIssuesAnalyticsPath(gon.current_organization.path, ...args);
  }

  return _groupIssuesAnalyticsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/insights/query(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const queryGroupInsightsPath = /*#__PURE__*/ (...args) => {
  const _queryOrganizationGroupInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _queryGroupInsightsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _queryOrganizationGroupInsightsPath(gon.current_organization.path, ...args);
  }

  return _queryGroupInsightsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/insights(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupInsightsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupInsightsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupInsightsPath(gon.current_organization.path, ...args);
  }

  return _groupInsightsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/notification_setting(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupNotificationSettingPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupNotificationSettingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"notification_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupNotificationSettingPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"notification_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupNotificationSettingPath(gon.current_organization.path, ...args);
  }

  return _groupNotificationSettingPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/ldap_group_links(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupLdapGroupLinksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLdapGroupLinksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupLdapGroupLinksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupLdapGroupLinksPath(gon.current_organization.path, ...args);
  }

  return _groupLdapGroupLinksPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/ldap_group_links/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupLdapGroupLinkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLdapGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupLdapGroupLinkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ldap_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupLdapGroupLinkPath(gon.current_organization.path, ...args);
  }

  return _groupLdapGroupLinkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/saml_group_links(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSamlGroupLinksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlGroupLinksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSamlGroupLinksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSamlGroupLinksPath(gon.current_organization.path, ...args);
  }

  return _groupSamlGroupLinksPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/saml_group_links/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSamlGroupLinkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSamlGroupLinkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml_group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSamlGroupLinkPath(gon.current_organization.path, ...args);
  }

  return _groupSamlGroupLinkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/audit_events(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAuditEventsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAuditEventsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAuditEventsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAuditEventsPath(gon.current_organization.path, ...args);
  }

  return _groupAuditEventsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/usage_quotas(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupUsageQuotasPath(gon.current_organization.path, ...args);
  }

  return _groupUsageQuotasPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/usage_quotas/pending_members(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pendingMembersGroupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _pendingMembersOrganizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"pending_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _pendingMembersGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"pending_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _pendingMembersOrganizationGroupUsageQuotasPath(gon.current_organization.path, ...args);
  }

  return _pendingMembersGroupUsageQuotasPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/usage_quotas/subscription_history(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptionHistoryGroupUsageQuotasPath = /*#__PURE__*/ (...args) => {
  const _subscriptionHistoryOrganizationGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"subscription_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _subscriptionHistoryGroupUsageQuotasPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[2,[7,"/"],[2,[6,"subscription_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _subscriptionHistoryOrganizationGroupUsageQuotasPath(gon.current_organization.path, ...args);
  }

  return _subscriptionHistoryGroupUsageQuotasPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks/:id/test(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testGroupHookPath = /*#__PURE__*/ (...args) => {
  const _testOrganizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _testGroupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationGroupHookPath(gon.current_organization.path, ...args);
  }

  return _testGroupHookPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks/:hook_id/hook_logs/:id/retry(.:format)
 * @param {any} groupId
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryGroupHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _retryOrganizationGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _retryGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationGroupHookHookLogPath(gon.current_organization.path, ...args);
  }

  return _retryGroupHookHookLogPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks/:hook_id/hook_logs/:id(.:format)
 * @param {any} groupId
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHookHookLogPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupHookHookLogPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHookHookLogPath(gon.current_organization.path, ...args);
  }

  return _groupHookHookLogPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHooksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHooksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupHooksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHooksPath(gon.current_organization.path, ...args);
  }

  return _groupHooksPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupHookPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupHookPath(gon.current_organization.path, ...args);
  }

  return _editGroupHookPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/hooks/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHookPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupHookPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHookPath(gon.current_organization.path, ...args);
  }

  return _groupHookPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/autocomplete_sources/epics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const epicsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _epicsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _epicsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _epicsOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _epicsGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/autocomplete_sources/iterations(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iterationsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _iterationsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _iterationsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _iterationsOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _iterationsGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/autocomplete_sources/vulnerabilities(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vulnerabilitiesGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _vulnerabilitiesOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _vulnerabilitiesGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _vulnerabilitiesOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _vulnerabilitiesGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/autocomplete_sources/wikis(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wikisGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _wikisOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _wikisGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _wikisOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _wikisGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/billings/refresh_seats(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshSeatsGroupBillingsPath = /*#__PURE__*/ (...args) => {
  const _refreshSeatsOrganizationGroupBillingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"refresh_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _refreshSeatsGroupBillingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"refresh_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _refreshSeatsOrganizationGroupBillingsPath(gon.current_organization.path, ...args);
  }

  return _refreshSeatsGroupBillingsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/billings/upgrade_subscription(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upgradeSubscriptionGroupBillingsPath = /*#__PURE__*/ (...args) => {
  const _upgradeSubscriptionOrganizationGroupBillingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"upgrade_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _upgradeSubscriptionGroupBillingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[2,[7,"/"],[2,[6,"upgrade_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _upgradeSubscriptionOrganizationGroupBillingsPath(gon.current_organization.path, ...args);
  }

  return _upgradeSubscriptionGroupBillingsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/billings(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupBillingsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupBillingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupBillingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupBillingsPath(gon.current_organization.path, ...args);
  }

  return _groupBillingsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/seat_usage(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSeatUsagePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSeatUsagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"seat_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSeatUsagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"seat_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSeatUsagePath(gon.current_organization.path, ...args);
  }

  return _groupSeatUsagePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/comment_templates(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCommentTemplatesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCommentTemplatesPath(gon.current_organization.path, ...args);
  }

  return _groupCommentTemplatesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/comment_templates/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCommentTemplatePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCommentTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupCommentTemplatePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCommentTemplatePath(gon.current_organization.path, ...args);
  }

  return _groupCommentTemplatePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/descriptions/:version_id/diff(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {any} versionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const descriptionDiffGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _descriptionDiffOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _descriptionDiffGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _descriptionDiffOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _descriptionDiffGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/descriptions/:version_id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {any} versionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteDescriptionVersionGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _deleteDescriptionVersionOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _deleteDescriptionVersionGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _deleteDescriptionVersionOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _deleteDescriptionVersionGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/discussions(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussionsGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _discussionsOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _discussionsGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _discussionsOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _discussionsGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/realtime_changes(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const realtimeChangesGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _realtimeChangesOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"realtime_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _realtimeChangesGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"realtime_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _realtimeChangesOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _realtimeChangesGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/toggle_subscription(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleSubscriptionGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _toggleSubscriptionOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleSubscriptionGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleSubscriptionOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _toggleSubscriptionGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:epic_id/notes(.:format)
 * @param {any} groupId
 * @param {any} epicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicNotesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"epic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupEpicNotesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"epic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicNotesPath(gon.current_organization.path, ...args);
  }

  return _groupEpicNotesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:epic_id/notes/:id(.:format)
 * @param {any} groupId
 * @param {any} epicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicNotePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupEpicNotePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicNotePath(gon.current_organization.path, ...args);
  }

  return _groupEpicNotePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/bulk_update(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateGroupEpicsPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupEpicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupEpicsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _bulkUpdateOrganizationGroupEpicsPath(gon.current_organization.path, ...args);
  }

  return _bulkUpdateGroupEpicsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupEpicsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicsPath(gon.current_organization.path, ...args);
  }

  return _groupEpicsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _newGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _editGroupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epics/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _groupEpicPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/iterations(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupIterationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationsPath(gon.current_organization.path, ...args);
  }

  return _groupIterationsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/iterations/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupIterationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupIterationPath(gon.current_organization.path, ...args);
  }

  return _newGroupIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/iterations/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupIterationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupIterationPath(gon.current_organization.path, ...args);
  }

  return _editGroupIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/iterations/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationPath(gon.current_organization.path, ...args);
  }

  return _groupIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations(.:format)
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationCadenceIterationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationCadenceIterationsPath(gon.current_organization.path, ...args);
  }

  return _groupIterationCadenceIterationsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/new(.:format)
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _newGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupIterationCadenceIterationPath(gon.current_organization.path, ...args);
  }

  return _newGroupIterationCadenceIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupIterationCadenceIterationPath(gon.current_organization.path, ...args);
  }

  return _editGroupIterationCadenceIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id(.:format)
 * @param {any} groupId
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationCadenceIterationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationCadenceIterationPath(gon.current_organization.path, ...args);
  }

  return _groupIterationCadenceIterationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationCadencesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadencesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _groupIterationCadencesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationCadencesPath(gon.current_organization.path, ...args);
  }

  return _groupIterationCadencesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _newGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupIterationCadencePath(gon.current_organization.path, ...args);
  }

  return _newGroupIterationCadencePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _editGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupIterationCadencePath(gon.current_organization.path, ...args);
  }

  return _editGroupIterationCadencePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/cadences(/*vueroute)/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupIterationCadencePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _groupIterationCadencePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupIterationCadencePath(gon.current_organization.path, ...args);
  }

  return _groupIterationCadencePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/issues/bulk_update(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateGroupIssuesPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _bulkUpdateOrganizationGroupIssuesPath(gon.current_organization.path, ...args);
  }

  return _bulkUpdateGroupIssuesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/merge_requests/bulk_update(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateGroupMergeRequestsPath = /*#__PURE__*/ (...args) => {
  const _bulkUpdateOrganizationGroupMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateGroupMergeRequestsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _bulkUpdateOrganizationGroupMergeRequestsPath(gon.current_organization.path, ...args);
  }

  return _bulkUpdateGroupMergeRequestsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/todos(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupTodosPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupTodosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupTodosPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupTodosPath(gon.current_organization.path, ...args);
  }

  return _groupTodosPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epic_boards(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicBoardsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicBoardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupEpicBoardsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicBoardsPath(gon.current_organization.path, ...args);
  }

  return _groupEpicBoardsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/epic_boards/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupEpicBoardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupEpicBoardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupEpicBoardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epic_boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupEpicBoardPath(gon.current_organization.path, ...args);
  }

  return _groupEpicBoardPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/protected_environments(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupProtectedEnvironmentsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupProtectedEnvironmentsPath(gon.current_organization.path, ...args);
  }

  return _groupProtectedEnvironmentsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/protected_environments/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupProtectedEnvironmentPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupProtectedEnvironmentPath(gon.current_organization.path, ...args);
  }

  return _groupProtectedEnvironmentPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/dashboard(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityDashboardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityDashboardPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityDashboardPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/inventory(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityInventoryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityInventoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityInventoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityInventoryPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityInventoryPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/configuration(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityConfigurationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityConfigurationPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityConfigurationPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/vulnerabilities(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityVulnerabilitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityVulnerabilitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityVulnerabilitiesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityVulnerabilitiesPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityVulnerabilitiesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/agent_artifacts(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityAgentArtifactsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityAgentArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityAgentArtifactsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityAgentArtifactsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityAgentArtifactsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_frameworks/import(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ (...args) => {
  const _importOrganizationGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _importGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _importOrganizationGroupSecurityComplianceFrameworksPath(gon.current_organization.path, ...args);
  }

  return _importGroupSecurityComplianceFrameworksPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_frameworks(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworksPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworksPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceFrameworksPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceFrameworksPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_frameworks/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSecurityComplianceFrameworkPath(gon.current_organization.path, ...args);
  }

  return _newGroupSecurityComplianceFrameworkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_frameworks/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSecurityComplianceFrameworkPath(gon.current_organization.path, ...args);
  }

  return _editGroupSecurityComplianceFrameworkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_frameworks/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceFrameworkPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceFrameworkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_dashboard/frameworks/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardFrameworkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"frameworks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceDashboardFrameworkPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceDashboardFrameworkPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_dashboard/exports/compliance_status_report(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"compliance_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardExportsComplianceStatusReportPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"compliance_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceDashboardExportsComplianceStatusReportPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceDashboardExportsComplianceStatusReportPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_dashboard/exports/violations_report(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"violations_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardExportsViolationsReportPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"violations_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceDashboardExportsViolationsReportPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceDashboardExportsViolationsReportPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_dashboard(/*vueroute)(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceDashboardPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceDashboardPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/discover(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityDiscoverPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityDiscoverPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityDiscoverPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/credentials/:credential_id/resources/:resource_id/revoke(.:format)
 * @param {any} groupId
 * @param {any} credentialId
 * @param {any} resourceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityCredentialResourceRevokePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialResourceRevokePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"credential_id":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"credential_id"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialResourceRevokePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"credential_id":{"r":true},"resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"credential_id"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityCredentialResourceRevokePath(gon.current_organization.path, ...args);
  }

  return _groupSecurityCredentialResourceRevokePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/credentials/:id/revoke(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeGroupSecurityCredentialPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _revokeGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationGroupSecurityCredentialPath(gon.current_organization.path, ...args);
  }

  return _revokeGroupSecurityCredentialPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/credentials(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityCredentialsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityCredentialsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityCredentialsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/credentials/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityCredentialPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSecurityCredentialPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityCredentialPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityCredentialPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/policies/schema(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schemaGroupSecurityPoliciesPath = /*#__PURE__*/ (...args) => {
  const _schemaOrganizationGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _schemaGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _schemaOrganizationGroupSecurityPoliciesPath(gon.current_organization.path, ...args);
  }

  return _schemaGroupSecurityPoliciesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/policies(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityPoliciesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityPoliciesPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityPoliciesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/policies/new(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSecurityPolicyPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSecurityPolicyPath(gon.current_organization.path, ...args);
  }

  return _newGroupSecurityPolicyPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/policies/:id/edit(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSecurityPolicyPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSecurityPolicyPath(gon.current_organization.path, ...args);
  }

  return _editGroupSecurityPolicyPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/merge_commit_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityMergeCommitReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityMergeCommitReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"merge_commit_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityMergeCommitReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"merge_commit_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityMergeCommitReportsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityMergeCommitReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_project_framework_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_project_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceProjectFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_project_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceProjectFrameworkReportsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceProjectFrameworkReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_violation_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceViolationReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceViolationReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violation_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceViolationReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violation_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceViolationReportsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceViolationReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_standards_adherence_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_standards_adherence_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceStandardsAdherenceReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_standards_adherence_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceStandardsAdherenceReportsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceStandardsAdherenceReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/security/compliance_framework_reports(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSecurityComplianceFrameworkReportsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_framework_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecurityComplianceFrameworkReportsPath(gon.current_organization.path, ...args);
  }

  return _groupSecurityComplianceFrameworkReportsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/add_ons/discover_duo_pro(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAddOnsDiscoverDuoProPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAddOnsDiscoverDuoProPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"add_ons"],[2,[7,"/"],[2,[6,"discover_duo_pro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAddOnsDiscoverDuoProPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"add_ons"],[2,[7,"/"],[2,[6,"discover_duo_pro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAddOnsDiscoverDuoProPath(gon.current_organization.path, ...args);
  }

  return _groupAddOnsDiscoverDuoProPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/add_ons/discover_duo_enterprise(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAddOnsDiscoverDuoEnterprisePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAddOnsDiscoverDuoEnterprisePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"add_ons"],[2,[7,"/"],[2,[6,"discover_duo_enterprise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupAddOnsDiscoverDuoEnterprisePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"add_ons"],[2,[7,"/"],[2,[6,"discover_duo_enterprise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAddOnsDiscoverDuoEnterprisePath(gon.current_organization.path, ...args);
  }

  return _groupAddOnsDiscoverDuoEnterprisePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/dependencies/licenses(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const licensesGroupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _licensesOrganizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _licensesGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _licensesOrganizationGroupDependenciesPath(gon.current_organization.path, ...args);
  }

  return _licensesGroupDependenciesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/dependencies/locations(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationsGroupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _locationsOrganizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _locationsGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _locationsOrganizationGroupDependenciesPath(gon.current_organization.path, ...args);
  }

  return _locationsGroupDependenciesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/dependencies(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupDependenciesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupDependenciesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupDependenciesPath(gon.current_organization.path, ...args);
  }

  return _groupDependenciesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/push_rules(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupPushRulesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPushRulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupPushRulesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupPushRulesPath(gon.current_organization.path, ...args);
  }

  return _groupPushRulesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/protected_branches(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupProtectedBranchesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedBranchesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupProtectedBranchesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupProtectedBranchesPath(gon.current_organization.path, ...args);
  }

  return _groupProtectedBranchesPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/protected_branches/:id(.:format)
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupProtectedBranchPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupProtectedBranchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupProtectedBranchPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupProtectedBranchPath(gon.current_organization.path, ...args);
  }

  return _groupProtectedBranchPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/saml/callback(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callbackGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /groups/*group_id/-/saml/sso(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssoGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /groups/*group_id/-/saml/unlink(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkGroupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _unlinkOrganizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _unlinkGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unlinkOrganizationGroupSamlProvidersPath(gon.current_organization.path, ...args);
  }

  return _unlinkGroupSamlProvidersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/saml/update_microsoft_application(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMicrosoftApplicationGroupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _updateMicrosoftApplicationOrganizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"update_microsoft_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _updateMicrosoftApplicationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"update_microsoft_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _updateMicrosoftApplicationOrganizationGroupSamlProvidersPath(gon.current_organization.path, ...args);
  }

  return _updateMicrosoftApplicationGroupSamlProvidersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/saml(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSamlProvidersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSamlProvidersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSamlProvidersPath(gon.current_organization.path, ...args);
  }

  return _groupSamlProvidersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/scim_oauth(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupScimOauthPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupScimOauthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"scim_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupScimOauthPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"scim_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupScimOauthPath(gon.current_organization.path, ...args);
  }

  return _groupScimOauthPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/roadmap(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupRoadmapPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupRoadmapPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"roadmap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupRoadmapPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"roadmap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupRoadmapPath(gon.current_organization.path, ...args);
  }

  return _groupRoadmapPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/work_items/:iid/descriptions/:version_id/diff(.:format)
 * @param {any} groupId
 * @param {any} iid
 * @param {any} versionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const descriptionDiffGroupWorkItemPath = /*#__PURE__*/ (...args) => {
  const _descriptionDiffOrganizationGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _descriptionDiffGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[2,[7,"/"],[2,[6,"diff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _descriptionDiffOrganizationGroupWorkItemPath(gon.current_organization.path, ...args);
  }

  return _descriptionDiffGroupWorkItemPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/work_items/:iid/descriptions/:version_id(.:format)
 * @param {any} groupId
 * @param {any} iid
 * @param {any} versionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteDescriptionVersionGroupWorkItemPath = /*#__PURE__*/ (...args) => {
  const _deleteDescriptionVersionOrganizationGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _deleteDescriptionVersionGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"iid":{"r":true},"version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"descriptions"],[2,[7,"/"],[2,[3,"version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _deleteDescriptionVersionOrganizationGroupWorkItemPath(gon.current_organization.path, ...args);
  }

  return _deleteDescriptionVersionGroupWorkItemPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/discover(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupDiscoverPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupDiscoverPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupDiscoverPath(gon.current_organization.path, ...args);
  }

  return _groupDiscoverPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/runners/dashboard(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardGroupRunnersPath = /*#__PURE__*/ (...args) => {
  const _dashboardOrganizationGroupRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _dashboardGroupRunnersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _dashboardOrganizationGroupRunnersPath(gon.current_organization.path, ...args);
  }

  return _dashboardGroupRunnersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate(/*vueroute)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomatePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]);
  const _groupAutomatePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomatePath(gon.current_organization.path, ...args);
  }

  return _groupAutomatePath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate/agents
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomateAgentsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]]]]]);
  const _groupAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomateAgentsPath(gon.current_organization.path, ...args);
  }

  return _groupAutomateAgentsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate/agents/:id
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomateAgentPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _groupAutomateAgentPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomateAgentPath(gon.current_organization.path, ...args);
  }

  return _groupAutomateAgentPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate/flows
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomateFlowsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]]]]]);
  const _groupAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomateFlowsPath(gon.current_organization.path, ...args);
  }

  return _groupAutomateFlowsPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate/flows/:id
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomateFlowPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateFlowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _groupAutomateFlowPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomateFlowPath(gon.current_organization.path, ...args);
  }

  return _groupAutomateFlowPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/automate/mcp-servers
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAutomateMcpServersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]]]]]);
  const _groupAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAutomateMcpServersPath(gon.current_organization.path, ...args);
  }

  return _groupAutomateMcpServersPath(...args);
};

/**
 * Generates rails route to
 * /groups/*group_id/-/secrets(/*vueroute)(.:format)
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSecretsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSecretsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _groupSecretsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSecretsPath(gon.current_organization.path, ...args);
  }

  return _groupSecretsPath(...args);
};

